import { withInstall } from "../utils/index.mjs";
import _GridItem from "./GridItem.mjs";
const GridItem = withInstall(_GridItem);
var stdin_default = GridItem;
import { gridItemProps } from "./GridItem.mjs";
export {
  GridItem,
  stdin_default as default,
  gridItemProps
};
